import { initializeIcons } from '@uifabric/icons';
import * as React from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { DefaultPage } from './App/Default';
import { PasswordChange } from './App/Identity/PasswordChange/PasswordChange'
import InvoiceContact from './App/Identity/InvoiceContact/InvoiceContact'
import EmailChange from './App/Identity/EmailChange/EmailChange'

import { MyEvents } from './App/Events/MyEvents/MyEvents'
import { MyInvoices } from './App/Invoices/MyInvoices/MyInvoices'
import { UserList } from './App/Admin/Users/UserList/UserList';
import { EventList } from './App/Admin/Events/Events/EventsList/EventsList';
import { EventTypeList } from './App/Admin/Events/EventTypes/EventTypeList/EventTypeList';
import { RoomList } from './App/Admin/Events/Rooms/RoomList/RoomList';
import { AgeGroupList } from './App/Admin/Events/AgeGroups/AgeGroupList/AgeGroupList';
import { MyOrderList } from './App/Orders/MyOrderList/MyOrderList';
import { OrderListAdmin } from './App/Admin/Order/OrderList/OrderListAdmin';
import { ContactInfo } from './App/Admin/ContactInfo/ContactInfo';
import { InvoiceList } from './App/Admin/Invoices/InvoiceList/InvoiceList';
import { TeacherEventList } from './App/Admin/Teacher/TeacherEventList';
import { TextsList } from './App/Admin/Texts/TextsList/TextsList';
import { ReportEventLessonsProgress } from './App/Admin/Reports/Admin/EventLessonsProgress';
import { ReportTeacherLessonsByMonth } from './App/Admin/Reports/Accountant/TeacherLessonsByMonth';
import { FindAttendee } from './App/Admin/Users/FindAttendee/FindAttendee';
import { PhotogalleryAdminList } from './App/Admin/Photogalery/PhotogalleryAdminList'; 
interface IAppProps {

}

export const PortalApp: React.FunctionComponent<IAppProps> = (props) => {

   

    return (<div>
        <Routes>

                {/*<Route path="/pokemon" element={<PokemonHome service={ServicesProvider} />} />*/}
            <Route path="/portal/events/myEvents" element={<MyEvents />} />
            <Route path="/portal/Invoices/myInvoices" element={<MyInvoices />} />
            <Route path="/portal/orders/myOrders" element={<MyOrderList />} />
            
            <Route path="/portal/orders/admin" element={<OrderListAdmin />} />

            <Route path="/portal/identity/password" element={<PasswordChange />} />


            <Route path="/portal/identity/password" element={<PasswordChange />} />
            <Route path="/portal/identity/invoiceContact" element={<InvoiceContact />} />
            <Route path="/portal/identity/emailChange" element={<EmailChange />} />

            <Route path="/portal/admin/Users" element={<UserList />} />
            <Route path="/portal/admin/FindAttendee" element={<FindAttendee />} />

            <Route path="/portal/admin/Events" element={<EventList />} />
            <Route path="/portal/admin/EventTypes" element={<EventTypeList />} />
            <Route path="/portal/admin/Rooms" element={<RoomList />} />
            <Route path="/portal/admin/AgeGroups" element={<AgeGroupList />} />
            
            <Route path="/portal" element={<DefaultPage />} />

            <Route path="/portal/admin/invoices/list" element={<InvoiceList showAddNewInvoice={true} showHeader={true} searchName={true} />} />
            <Route path="/portal/admin/payments/list" element={<DefaultPage />} />

            <Route path="/portal/admin/contactInfo" element={<ContactInfo />} />
            <Route path="/portal/teacher/Events" element={<TeacherEventList />} />
            <Route path="/portal/admin/texts" element={<TextsList />} />
            <Route path="/portal/admin/texts" element={<TextsList />} />
            <Route path="/portal/report/EventLessonsProgress" element={<ReportEventLessonsProgress />} />
            <Route path="/portal/report/TeacherLessonsByMonth" element={<ReportTeacherLessonsByMonth />} />
            <Route path="/portal/Fotogalerie/admin" element={<PhotogalleryAdminList />} />
            
            </Routes>

    </div>)
}
